import React from 'react';
import { buttonStyle, sectionHeaderStyle } from './styles';

interface PlayerActionsProps {
  onAction: (action: string, data?: any) => void;
}

export const PlayerActions: React.FC<PlayerActionsProps> = ({ onAction }) => {
  return (
    <>
      <div style={sectionHeaderStyle}>Actions</div>
      <button style={buttonStyle} onClick={() => onAction('heal')}>❤️ Heal Full</button>
      <button style={buttonStyle} onClick={() => onAction('mana')}>💧 Mana Full</button>
      <button style={buttonStyle} onClick={() => onAction('levelup')}>⭐ Level Up</button>
      <button style={buttonStyle} onClick={() => onAction('addxp', 100)}>➕ Add 100 XP</button>
      <button style={{ ...buttonStyle, background: '#9b59b6', borderColor: '#8e44ad' }} onClick={() => onAction('force_sync_stats')}>🔄 Force Sync Stats</button>
      <button style={{ ...buttonStyle, background: '#e74c3c', borderColor: '#c0392b' }} onClick={() => onAction('respawn')}>🔄 Respawn Player</button>
      <button style={{ ...buttonStyle, background: '#27ae60', borderColor: '#2ecc71' }} onClick={() => onAction('save_player')}>💾 Save Player</button>
    </>
  );
};
